const CONTROL_CHARACTER_PATTERN = /\p{Cc}/u;

export function hasControlCharacter(text: string): boolean {
  return CONTROL_CHARACTER_PATTERN.test(text);
}
